import React from 'react';
import ReactDOM from 'react-dom';

import App from './App';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// PWA: registrar el service worker (shell offline + instalable en el teléfono).
// Best-effort: si el registro falla, la app funciona igual. El SW usa
// network-first para la navegación, así un deploy nuevo se ve al toque online.
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register(`${process.env.PUBLIC_URL}/service-worker.js`)
      .catch(() => {
        /* sin SW: la consola sigue operando con normalidad */
      });
  });
}
